// ;(function () {
// 	var form = document.forms['crrsaa-form'];

// 	form.querySelector( '[type="submit"]' ).addEventListener( 'click', function ( e ) {
// 		e.preventDefault();

// 		if ( ! form.checkValidity() ) {
// 			form.reportValidity();
// 		} else {
// 			if ( window.grecaptcha ) {
// 				window.grecaptcha.execute();
// 			} else {
// 				form.submit();
// 			}
// 		}
// 	});
// }());

;(function () {
	var canvas = document.getElementById( 'frm-signature' );

	canvas.width = canvas.closest( '.form-field' ).clientWidth;

	const signatureDataField = canvas.closest( 'div' ).querySelector( 'input' );

	var signaturePad = new SignaturePad(canvas, {
		onEnd: function ( e ) {
			signatureDataField.value = signaturePad.toDataURL();
		}
	});

	if ( signatureDataField.value ) {
		signaturePad.fromDataURL( signatureDataField.value );
	}

	canvas.parentNode.querySelector( 'button' )
		.addEventListener( 'click', e => {
			e.preventDefault();
			signaturePad.clear();
		});

	var form = canvas.closest( 'form' );

	form.querySelector( '[type="submit"]' ).addEventListener( 'click', function ( e ) {
		e.preventDefault();

		if ( ! form.checkValidity() ) {
			form.reportValidity();
		} else if ( signaturePad.isEmpty() ) {
			jQuery( canvas ).parent().find( '.error-message' ).remove();
			showErrorMessage( 'Signature is required.', canvas );
			jQuery( canvas ).parent().find( '.error-message' )[0].scrollIntoView();
		} else {
			if ( window.grecaptcha ) {
				window.grecaptcha.execute();
			} else {
				form.submit();
			}
		}
	});

	function showErrorMessage( message, element ) {
		const errorElement = document.createElement( 'span' );
		const errorMessage = document.createTextNode( message );
		errorElement.appendChild( errorMessage );
		errorElement.classList.add( 'error-message' );
		element.insertAdjacentElement(
			'beforebegin',
			errorElement
		);
	}

	// jQuery( function () {
	// 	const programFields = document.querySelectorAll( 'input[name="programs[]"]' );
	// 	jQuery( programFields ).each( ( _, elem ) => {
	// 		elem.required = true;
	// 	}).on( 'change', function ( _ ) {
	// 		let checked = false;

	// 		jQuery( programFields ).each( ( _, elem ) => {
	// 			if ( elem.checked ) {
	// 				checked = true;
	// 			}
	// 		});
	// 		jQuery( programFields ).each( ( _, elem ) => {
	// 			elem.required = ! checked;
	// 			console.log( 'set programs required', ! checked );
	// 		});
	// 		console.log( 'programs change fired' );
	// 	}).trigger( 'change' );

	// 	const certField = document.querySelector( 'input[name="certification"]' );
	// 	const degreeFields = document.querySelectorAll( 'input[name="degree"]' );
	// 	certField.required = true;
	// 	jQuery( degreeFields ).each( ( _, elem ) => {
	// 		elem.required = true;
	// 	}).on( 'change', _ => {
	// 		let checked = false;

	// 		jQuery( degreeFields ).each( ( _, elem ) => {
	// 			if ( elem.checked ) {
	// 				checked = true;
	// 			}
	// 		});

	// 		certField.required = ! checked;

	// 		if ( checked ) {
	// 			certField.checked = false;
	// 		}
	// 	}).trigger( 'change' );
	// 	jQuery( certField ).on( 'change', _ => {
	// 		jQuery( degreeFields ).each( ( _, elem ) => {
	// 			elem.required = ! certField.checked;

	// 			if ( certField.checked ) {
	// 				elem.checked = false;
	// 			}
	// 		});
	// 	}).trigger( 'change' );
	// });
}());

